<template>
	<div class="analytics-sparkline shrink-0 overflow-hidden" :style="{ width: `${width}px`, height: `${height}px` }" aria-hidden="true">
		<VueApexCharts
			v-if="hasData"
			type="line"
			:width="width"
			:height="height"
			:options="options"
			:series="series"
		/>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import VueApexCharts from 'vue3-apexcharts';

const props = defineProps({
	// Plain numbers, in order.
	values: {
		type: Array,
		default: () => [],
	},
	width: {
		type: Number,
		default: 64,
	},
	height: {
		type: Number,
		default: 28,
	},
	color: {
		type: String,
		default: '#2076FF',
	},
});

const hasData = computed(() => Array.isArray(props.values) && props.values.length >= 2);

const series = computed(() => [{ name: '', data: props.values.map((v) => Number(v) || 0) }]);

const options = computed(() => ({
	chart: {
		type: 'line',
		sparkline: { enabled: true },
		animations: { enabled: false },
		parentHeightOffset: 0,
	},
	stroke: { curve: 'smooth', width: 1.5, lineCap: 'round' },
	colors: [props.color],
	// For line charts Apex derives the stroke from fill.opacity, so keep it 1.
	fill: { type: 'solid', opacity: 1 },
	markers: { size: 0 },
	tooltip: { enabled: false },
	grid: { padding: { top: 2, right: 1, bottom: 2, left: 1 } },
	yaxis: { min: 0, show: false },
	xaxis: { labels: { show: false }, axisBorder: { show: false }, axisTicks: { show: false } },
}));
</script>

<style scoped>
.analytics-sparkline :deep(.apexcharts-canvas) {
	line-height: 0;
}
</style>
